// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table[data-v-2d6b0125]{margin-top:10px;width:100%}#bill-top[data-v-2d6b0125]{padding:5px;margin-inline:2%;border-bottom:2px solid #20b2aa}.error-message[data-v-2d6b0125]{text-align:center}#bill-bar[data-v-2d6b0125]{display:flex;justify-content:space-between;align-items:center}.del-bill[data-v-2d6b0125]{font-size:20px}#change-period input[data-v-2d6b0125],.del-bill[data-v-2d6b0125]{margin-left:10px}", ""]);
// Exports
module.exports = exports;
